'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function App(_ref) {
  var children = _ref.children,
      setPageTitle = _ref.setPageTitle;

  return _react2.default.createElement(
    'div',
    { className: 'App' },
    _react2.default.createElement(_components.Header, null),
    _react2.default.cloneElement(children, { setPageTitle: setPageTitle }),
    _react2.default.createElement(_components.Footer, null)
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/App.js
// module id = 1160
// module chunks = 0